/**
 * @generated SignedSource<<451aa8bc5c1c56d20e3c24f4af953963>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type HubStatus = "OFFLINE" | "ONLINE" | "%future added value";
export type SpaceConfiguration = "BACE_CLATTERING_STANDARD" | "BACE_SATELLITE_LARGE_EXTENDED" | "BACE_SATELLITE_LARGE_STANDARD" | "BACE_SATELLITE_MEDIUM_EXTENDED" | "BACE_SATELLITE_MEDIUM_STANDARD" | "BACE_SATELLITE_SMALL_EXTENDED" | "BACE_SATELLITE_SMALL_SLIM" | "BACE_SATELLITE_SMALL_STANDARD" | "BACE_STOREFRONT_2XL" | "BACE_STOREFRONT_L" | "BACE_STOREFRONT_M" | "BACE_STOREFRONT_S" | "BACE_STOREFRONT_XL" | "BACE_TRUCK_HUB_STANDARD" | "THALIA_RENZ_STANDARD_M" | "THALIA_RENZ_STANDARD_S" | "THALIA_RENZ_STANDARD_XS" | "THALIA_RENZ_WIDE_M" | "THALIA_RENZ_WIDE_S" | "%future added value";
export type warenannahmeDeliverQuery$variables = {
  hubName: string;
  organizationId: string;
};
export type warenannahmeDeliverQuery$data = {
  readonly deliveryRequests: {
    readonly nodes: ReadonlyArray<{
      readonly content: string;
      readonly createdAt: any;
      readonly hubId: string;
      readonly id: string;
      readonly preferredSize: string | null | undefined;
      readonly requesterOrganization: {
        readonly id: string;
        readonly name: string;
      };
    }>;
  };
  readonly hubMeta: {
    readonly capacityOverview: {
      readonly flexCapacityAvailable: number;
    };
    readonly hub: {
      readonly availableConfigurations: ReadonlyArray<{
        readonly configuration: SpaceConfiguration;
        readonly dimensions: {
          readonly depthMm: number;
          readonly heightMm: number;
          readonly widthMm: number;
        };
        readonly numSpaces: number;
        readonly spaces: ReadonlyArray<{
          readonly frame: string;
          readonly id: string;
        }>;
      }>;
      readonly id: string;
      readonly spaces: ReadonlyArray<{
        readonly frame: string;
      }>;
      readonly status: HubStatus;
    };
    readonly id: string;
    readonly lat: number;
    readonly lng: number;
    readonly name: string;
    readonly organizationCapacity: {
      readonly fixedAvailable: number;
    };
  };
};
export type warenannahmeDeliverQuery = {
  response: warenannahmeDeliverQuery$data;
  variables: warenannahmeDeliverQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "organizationId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "direction": "RECEIVED",
        "status": [
          "OPEN"
        ]
      }
    },
    {
      "kind": "Literal",
      "name": "pagination",
      "value": {
        "page": 0,
        "pageSize": 100
      }
    }
  ],
  "concreteType": "DeliveryRequestPage",
  "kind": "LinkedField",
  "name": "deliveryRequests",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DeliveryRequest",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hubId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "content",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "preferredSize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Organization",
          "kind": "LinkedField",
          "name": "requesterOrganization",
          "plural": false,
          "selections": [
            (v1/*:: as any*/),
            (v2/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "deliveryRequests(filter:{\"direction\":\"RECEIVED\",\"status\":[\"OPEN\"]},pagination:{\"page\":0,\"pageSize\":100})"
},
v4 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "hubName"
      }
    ],
    "kind": "ObjectValue",
    "name": "by"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lat",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lng",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "organizationId",
      "variableName": "organizationId"
    }
  ],
  "concreteType": "HubOrganizationCapacity",
  "kind": "LinkedField",
  "name": "organizationCapacity",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fixedAvailable",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "HubCapacityOverview",
  "kind": "LinkedField",
  "name": "capacityOverview",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flexCapacityAvailable",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "frame",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Hub",
  "kind": "LinkedField",
  "name": "hub",
  "plural": false,
  "selections": [
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "spaces",
      "plural": true,
      "selections": [
        (v9/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AvailableSpaceConfiguration",
      "kind": "LinkedField",
      "name": "availableConfigurations",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numSpaces",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "configuration",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "OutputDimensions",
          "kind": "LinkedField",
          "name": "dimensions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "widthMm",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "heightMm",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "depthMm",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Space",
          "kind": "LinkedField",
          "name": "spaces",
          "plural": true,
          "selections": [
            (v1/*:: as any*/),
            (v9/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "String"
},
v12 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "UUID"
},
v13 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Int"
},
v14 = {
  "enumValues": null,
  "nullable": false,
  "plural": true,
  "type": "Space"
},
v15 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Float"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "warenannahmeDeliverQuery",
    "selections": [
      (v3/*:: as any*/),
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v4/*:: as any*/),
          "concreteType": "HubMeta",
          "kind": "LinkedField",
          "name": "hubMeta",
          "plural": false,
          "selections": [
            (v1/*:: as any*/),
            (v2/*:: as any*/),
            (v5/*:: as any*/),
            (v6/*:: as any*/),
            (v7/*:: as any*/),
            (v8/*:: as any*/),
            {
              "kind": "RequiredField",
              "field": (v10/*:: as any*/),
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "warenannahmeDeliverQuery",
    "selections": [
      (v3/*:: as any*/),
      {
        "alias": null,
        "args": (v4/*:: as any*/),
        "concreteType": "HubMeta",
        "kind": "LinkedField",
        "name": "hubMeta",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          (v10/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "302a5d54e007778c10a5f10c462673f4",
    "id": null,
    "metadata": {
      "relayTestingSelectionTypeInfo": {
        "deliveryRequests": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "DeliveryRequestPage"
        },
        "deliveryRequests.nodes": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "DeliveryRequest"
        },
        "deliveryRequests.nodes.content": (v11/*:: as any*/),
        "deliveryRequests.nodes.createdAt": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "DateTime"
        },
        "deliveryRequests.nodes.hubId": (v12/*:: as any*/),
        "deliveryRequests.nodes.id": (v12/*:: as any*/),
        "deliveryRequests.nodes.preferredSize": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "String"
        },
        "deliveryRequests.nodes.requesterOrganization": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Organization"
        },
        "deliveryRequests.nodes.requesterOrganization.id": (v12/*:: as any*/),
        "deliveryRequests.nodes.requesterOrganization.name": (v11/*:: as any*/),
        "hubMeta": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "HubMeta"
        },
        "hubMeta.capacityOverview": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "HubCapacityOverview"
        },
        "hubMeta.capacityOverview.flexCapacityAvailable": (v13/*:: as any*/),
        "hubMeta.hub": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Hub"
        },
        "hubMeta.hub.availableConfigurations": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "AvailableSpaceConfiguration"
        },
        "hubMeta.hub.availableConfigurations.configuration": {
          "enumValues": [
            "BACE_STOREFRONT_S",
            "BACE_STOREFRONT_M",
            "BACE_STOREFRONT_L",
            "BACE_STOREFRONT_XL",
            "BACE_STOREFRONT_2XL",
            "BACE_SATELLITE_SMALL_STANDARD",
            "BACE_SATELLITE_SMALL_SLIM",
            "BACE_SATELLITE_SMALL_EXTENDED",
            "BACE_SATELLITE_MEDIUM_STANDARD",
            "BACE_SATELLITE_MEDIUM_EXTENDED",
            "BACE_SATELLITE_LARGE_STANDARD",
            "BACE_SATELLITE_LARGE_EXTENDED",
            "BACE_CLATTERING_STANDARD",
            "BACE_TRUCK_HUB_STANDARD",
            "THALIA_RENZ_STANDARD_XS",
            "THALIA_RENZ_STANDARD_S",
            "THALIA_RENZ_STANDARD_M",
            "THALIA_RENZ_WIDE_S",
            "THALIA_RENZ_WIDE_M"
          ],
          "nullable": false,
          "plural": false,
          "type": "SpaceConfiguration"
        },
        "hubMeta.hub.availableConfigurations.dimensions": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "OutputDimensions"
        },
        "hubMeta.hub.availableConfigurations.dimensions.depthMm": (v13/*:: as any*/),
        "hubMeta.hub.availableConfigurations.dimensions.heightMm": (v13/*:: as any*/),
        "hubMeta.hub.availableConfigurations.dimensions.widthMm": (v13/*:: as any*/),
        "hubMeta.hub.availableConfigurations.numSpaces": (v13/*:: as any*/),
        "hubMeta.hub.availableConfigurations.spaces": (v14/*:: as any*/),
        "hubMeta.hub.availableConfigurations.spaces.frame": (v11/*:: as any*/),
        "hubMeta.hub.availableConfigurations.spaces.id": (v12/*:: as any*/),
        "hubMeta.hub.id": (v12/*:: as any*/),
        "hubMeta.hub.spaces": (v14/*:: as any*/),
        "hubMeta.hub.spaces.frame": (v11/*:: as any*/),
        "hubMeta.hub.status": {
          "enumValues": [
            "ONLINE",
            "OFFLINE"
          ],
          "nullable": false,
          "plural": false,
          "type": "HubStatus"
        },
        "hubMeta.id": (v12/*:: as any*/),
        "hubMeta.lat": (v15/*:: as any*/),
        "hubMeta.lng": (v15/*:: as any*/),
        "hubMeta.name": (v11/*:: as any*/),
        "hubMeta.organizationCapacity": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "HubOrganizationCapacity"
        },
        "hubMeta.organizationCapacity.fixedAvailable": (v13/*:: as any*/)
      }
    },
    "name": "warenannahmeDeliverQuery",
    "operationKind": "query",
    "text": "query warenannahmeDeliverQuery(\n  $hubName: String!\n  $organizationId: UUID!\n) {\n  deliveryRequests(filter: {direction: RECEIVED, status: [OPEN]}, pagination: {page: 0, pageSize: 100}) {\n    nodes {\n      id\n      hubId\n      createdAt\n      content\n      preferredSize\n      requesterOrganization {\n        id\n        name\n      }\n    }\n  }\n  hubMeta(by: {name: $hubName}) {\n    id\n    name\n    lat\n    lng\n    organizationCapacity(organizationId: $organizationId) {\n      fixedAvailable\n    }\n    capacityOverview {\n      flexCapacityAvailable\n    }\n    hub {\n      id\n      status\n      spaces {\n        frame\n      }\n      availableConfigurations {\n        numSpaces\n        configuration\n        dimensions {\n          widthMm\n          heightMm\n          depthMm\n        }\n        spaces {\n          id\n          frame\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "31de4dfec457e5cf180f3dc5211198d9";

export default node;
